import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';
import { Component, Vue } from 'vue-property-decorator';
import { UserProfileViewModel } from '@/common/viewModels';
import TelstraUIVueSvg from '../TelstraUIVueSvg/TelstraUIVueSvg.vue';
import { AppStoreModule } from '@/store';
import AppStore from '@/store/modules/AppStoreModule';

@Component({
  components: {
    AppHeaderDropdown,
    TelstraUIVueSvg,
  },
})
export default class TelstraUIVueUserHeader extends Vue {
  app$: AppStore = AppStoreModule;
  user: UserProfileViewModel | undefined = this.app$.myProfile;

  get isExternalAuthenticationEnabled(): boolean {
    return this.$appConfig.featureFlags.externalAuthenticationEnabled;
  }

  logOut() {
    this.$factory.createAuthService().logout();
    this.$forceUpdate();
  }
}
